// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#purchase-restriction {
  background-color: #fffcd5;
  padding: 15px;
  font-family: AvenirNextLTW01-Regular, Arial;
  font-size: 14px;
  color: #333;
  border-bottom: 1px solid #ccc;
}
`, "",{"version":3,"sources":["webpack://./src/components/SectionComponents/Summary.vue","webpack://./Summary.vue"],"names":[],"mappings":"AACA;EACC,yBAAA;EACA,aAAA;EACA,2CAAA;EACA,eAAA;EACA,WAAA;EACA,6BAAA;ACAD","sourcesContent":["\n#purchase-restriction {\n\tbackground-color: #fffcd5;\n\tpadding: 15px;\n\tfont-family: AvenirNextLTW01-Regular, Arial;\n\tfont-size: 14px;\n\tcolor: #333;\n\tborder-bottom: 1px solid #ccc;\n}\n","#purchase-restriction {\n  background-color: #fffcd5;\n  padding: 15px;\n  font-family: AvenirNextLTW01-Regular, Arial;\n  font-size: 14px;\n  color: #333;\n  border-bottom: 1px solid #ccc;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
